<template>
  <section class="aidrama-box6">
    <!-- Pixso 65:4071 part6 — 393×813@1×；rem = @1× px × 2 -->
    <div class="aidrama-box6__inner">
      <header class="aidrama-box6__head">
        <h2 class="aidrama-box6__title">
          <span class="aidrama-box6__title-line aidrama-box6__title-line--accent">专业名师坐镇</span>
          <span class="aidrama-box6__title-line">精通AI漫剧全流程</span>
        </h2>
        <p class="aidrama-box6__sub">大咖执教赋能创作</p>
      </header>

      <div class="aidrama-box6__teachers">
        <img class="aidrama-box6__teachers-img" :src="teachersGrid" alt="" aria-hidden="true" />
        <div class="aidrama-box6__cards">
          <article v-for="teacher in teachers" :key="teacher.name" class="aidrama-box6-teacher">
            <div class="aidrama-box6-teacher__panel">
              <p class="aidrama-box6-teacher__name">{{ teacher.name }}</p>
              <span class="aidrama-box6-teacher__tag" :class="`aidrama-box6-teacher__tag--${teacher.tagTone}`">{{
                teacher.tag }}</span>
              <p v-if="teacher.descLines.length === 1" class="aidrama-box6-teacher__desc">
                {{ teacher.descLines[0] }}
              </p>
              <div v-else class="aidrama-box6-teacher__desc">
                <p v-for="line in teacher.descLines" :key="line">{{ line }}</p>
              </div>
            </div>
          </article>
        </div>
      </div>

      <button type="button" class="aidrama-box6__cta" @click="handleCtaClick">
        <span class="aidrama-box6__cta-text">与老师一对一沟通</span>
        <img class="aidrama-box6__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox6",
  data() {
    return {
      teachersGrid: require("../../../assets/coursePage/aidrama/box6/teachers_grid.png"),
      btnArrow: require("../../../assets/coursePage/aidrama/box6/btn_arrow.png"),
      teachers: [
        {
          name: "谭老师",
          tag: "AI技术专家",
          tagTone: "blue",
          descLines: [
            "传智教育集团AI设计教学总监",
            "湖北省书法/美术/硬笔书法家协会会员",
            "长江文艺出版集团邀约讲师",
            "68联盟专访设计师",
          ],
        },
        {
          name: "张老师",
          tag: "美术设计专家",
          tagTone: "purple",
          descLines: [
            "传智教育集团AI设计讲师",
            "大连艺术学院服装与服饰设计",
            "兼具高级视觉/高级3D/AIGC视觉设计师",
            "三重专业认证",
          ],
        },
        {
          name: "李老师",
          tag: "漫剧变现运营专家",
          tagTone: "blue",
          descLines: [
            "传智教育集团AI设计讲师",
            "中央美术学院陈设艺术设计",
            "曾任百度、湖南卫视等创意总监",
            "丰富的实战经验",
          ],
        },
        {
          name: "郑老师",
          tag: "资深编导专家",
          tagTone: "purple",
          descLines: [
            "传智教育集团AIGC视频全流程制作&数字内容创研员",
            "AIGC行业3年经验，负责宣传片、漫剧、电商广告等项目",
          ],
        },
      ],
    };
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第6屏-与老师一对一沟通", {
          终端: "H5",
          名称: "传智AI漫剧页-第6屏-与老师一对一沟通",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box6 {
  width: 100%;
  box-sizing: border-box;
  background-color: rgba(231, 243, 255, 1);
}

.aidrama-box6__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 82px 102px;
  box-sizing: border-box;
}

/* 65:4072 gap 6px */
.aidrama-box6__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box6__title {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
}

.aidrama-box6__title-line {
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(47, 52, 59, 1);
  white-space: nowrap;
}

.aidrama-box6__title-line--accent {
  color: rgba(79, 86, 255, 1);
}

.aidrama-box6__sub {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 65:4075 — 311×507.5；卡 150 宽，列 gap 21 */
.aidrama-box6__teachers {
  position: relative;
  width: 100%;
  margin-top: 48px;
}

.aidrama-box6__teachers-img {
  display: block;
  width: 100%;
  height: auto;
}

.aidrama-box6__cards {
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  column-gap: 42px;
  pointer-events: none;
}

.aidrama-box6-teacher {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  width: 300px;
  min-width: 0;
}

.aidrama-box6-teacher__panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 300px;
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 24px;
  background: linear-gradient(225.00deg, rgba(195, 255, 253, 0) 0%, rgba(167, 217, 255, 0.9) 50.422%, rgba(255, 255, 255, 0.8) 100%);
}

.aidrama-box6-teacher:nth-child(4) .aidrama-box6-teacher__panel {
  margin-bottom: 32px;
}

.aidrama-box6-teacher__name {
  margin: 0;
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  color: rgba(47, 52, 59, 1);
  white-space: nowrap;
}

.aidrama-box6-teacher__tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 12px;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 2px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box6-teacher__tag--blue {
  background: linear-gradient(270deg,
      rgba(54, 126, 255, 1) 0%,
      rgba(71, 175, 255, 1) 100%);
}

.aidrama-box6-teacher__tag--purple {
  background: linear-gradient(270deg,
      rgba(121, 79, 255, 1) 0%,
      rgba(167, 130, 255, 1) 100%);
}

.aidrama-box6-teacher__desc {
  margin: 0;
  max-width: 100%;
  font-size: 20px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 32px;
  color: rgba(47, 52, 59, 1);
}

.aidrama-box6-teacher__desc p {
  margin: 0;
}

/* 65:4100 */
.aidrama-box6__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 48px;
  padding: 36px 60px 36px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(270deg,
      rgba(188, 117, 255, 1) 0%,
      rgba(117, 104, 255, 1) 100%);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box6__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box6__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
